import Vue from 'vue';
import { formatMoney, formatDate } from './utils';

Vue.filter('formatMoney', formatMoney);
Vue.filter('formatDate', formatDate);
